import { CByteArray } from "./CByteArray";
import { CGame } from "./CGame";
import { CPacket } from "./CPacket";

export class CNetPeer {
    public static ID_MSG_CONNECT_REQUEST:number = 1;
    public static ID_MSG_DISCONNECTION:number = 3;
    public static ID_MSG_NEED_PASSWORD:number = 4;
    public static ID_MSG_INCOMING_PASSWORD:number = 5;
    public static ID_MSG_CONNECTION_ACCEPTED:number = 6;
    public static ID_MSG_ECHO:number = 10;
    public static ID_MSG_PING2CLIENT:number = 12;
    public static ID_MSG_PING_REPLY:number = 14;
    public static ID_MSG_RELIABLE_DATA:number = 15;
	public static ID_MSG_ACK_S2C:number = 16;
    public static ID_MSG_ACK_C2S:number = 17;

    //public static self:CNetPeer;

    private m_WS:WebSocket;
    private m_fgConnected:boolean;
	private m_recvPacketList:Array<CByteArray>;
    private m_messageBuffer = new Map();
	private m_errFunc:Function;
    private m_Name:string;
    private m_nextExpectedId:number;

    private m_nextSeqID:number = 1;
	private m_pendingPackets: Map<number, {pkt: CPacket, time: number, retry: number}> = new Map();

    public constructor() {
		this.m_errFunc = null;
        this.m_WS = null;
        this.m_fgConnected = false;
		this.m_recvPacketList = new Array<CByteArray>();
        this.m_nextExpectedId = 1;
        this.m_nextSeqID = 1;
    }
    public Connect(name:string, url:string, errFunc?:Function):void {
        //CNetPeer.self = this;
        if( errFunc ) this.m_errFunc = errFunc;
        this.m_recvPacketList.length = 0;
        this.m_nextExpectedId = 1;
        this.m_nextSeqID = 1;
        this.m_messageBuffer.clear();
        this.m_pendingPackets.clear();
        this.m_Name = name;
		this.m_WS = new WebSocket(url);
        this.m_WS.binaryType = 'arraybuffer';
        this.m_WS.onopen = this.onOpen.bind(this);
        this.m_WS.onmessage = this.onMessage.bind(this);
       	this.m_WS.onerror = this.onError.bind(this);
        this.m_WS.onclose = this.onClose.bind(this);
        //CNet.div = document.getElementById("canvasContainer");
    }
	public CloseConnect():void {
		if( this.m_fgConnected ) {
            this.m_fgConnected = false;
			if( this.m_WS ) this.m_WS.close();
		}
	}

    public ResetErrorFunc():void {
        this.m_errFunc = null;
    }

    private PushToPacketListV(type:number):void {
        var pkt:CByteArray = new CByteArray(4);
        pkt.SetByte(0, type);
        this.m_recvPacketList.push(pkt);
    }
    private PushToPacketList(msg:ArrayBuffer):void {
        var pkt:CByteArray = new CByteArray(msg);
        //console.log("PushToPacketList:"+msg.byteLength+":"+pkt.GetByte(0));
        this.m_recvPacketList.push(pkt);
    }
	private PopFromPacketList():CByteArray {
		var pkt:CByteArray = null;
		if ( this.m_recvPacketList.length > 0 ) {
			pkt = this.m_recvPacketList.shift();
		}
        //console.log("m_recvPacketList length:" + this.m_recvPacketList.length);
		return pkt;
	}
	public PushBack2PacketList(pkt:CByteArray, first:boolean=true):void {
		if ( first ) this.m_recvPacketList.unshift(pkt);
		else this.m_recvPacketList.push(pkt);
	}
	public DeallocatePacket(pkt:CByteArray):void {
		pkt = null;
	}
	public GetRecvPacket():CByteArray {
		var pkt:CByteArray = this.PopFromPacketList();
		return pkt;
	}
    public PacketListSize():number { return this.m_recvPacketList.length; }
    public isConnected():boolean{ return this.m_fgConnected; }

    private onOpen(evt: any) {
        console.log("CNetPeer onOpen ...");
        this.m_fgConnected = true;
        //CNetPeer.self.PushToPacketListV(CNetPeer.ID_MSG_CONNECTION_ACCEPTED);
    }
    private sendAck(msgId:number) {
        const ackBuffer = new ArrayBuffer(5);
        const view = new DataView(ackBuffer);
        view.setUint8(0, CNetPeer.ID_MSG_ACK_S2C);
        view.setUint32(1, msgId, true); // 務必與 C++ 端的字節序一致
        this.m_WS.send(ackBuffer);
    }

    private handleMessageOrder(msgId:number, data:ArrayBuffer) {
        // 如果收到的是舊的訊息 (重傳過來的)，直接丟棄
        if (msgId < this.m_nextExpectedId) return;

        // 存入緩衝區
        this.m_messageBuffer.set(msgId, data);

        // 嘗試按順序取出訊息處理
        while (this.m_messageBuffer.has(this.m_nextExpectedId)) {
            const dataToProcess = this.m_messageBuffer.get(this.m_nextExpectedId);
            this.PushToPacketList(dataToProcess);
            // processBusinessLogic(this.m_nextExpectedId, dataToProcess);
            
            this.m_messageBuffer.delete(this.m_nextExpectedId);
            this.m_nextExpectedId++;
        }
    }

    private onMessage(evt: any) {
        // console.log("CNetPeer onMessage ...");
		if (evt.data instanceof ArrayBuffer) {
            const buffer = evt.data;
            const view = new DataView(buffer);
            // 1. 讀取第一個 Byte (Type)
            const type = view.getUint8(0);
            if (type === CNetPeer.ID_MSG_RELIABLE_DATA) {
                // if( CGame.Instance.m_pUserPlayer.DBID <= 260400002 ) {
                //     if( CGame.GetRand(0, 100) < 50 ) {
                //         console.log("****** simulate lost packet ....");
                //         return;
                //     }
                // }
                // 2. 讀取接下來的 4 Bytes (MsgId) - 小端序 (Little Endian) 取決於 C++ 端的 memcpy
                const msgId = view.getUint32(1, true); 
                // console.log("收到RELIABLE_DATA:", msgId);
                // 3. 提取真正的數據負載 (Payload)
                const payload = buffer.slice(5); 
                // --- 立即回傳 ACK 給 Server ---
                this.sendAck(msgId);
                // --- 處理訊息順序 ---
                this.handleMessageOrder(msgId, payload);
            } 
            else if (type === CNetPeer.ID_MSG_ACK_C2S) {
				const msgId = view.getUint32(1, true);
				if (this.m_pendingPackets.has(msgId)) {
					this.m_pendingPackets.delete(msgId);
					// console.log("Received ACK for: " + msgId);
				}
			}
            else {
                // 處理一般訊息 (如 ID_MSG_CONNECTION_ACCEPTED 等)
                // console.log("收到一般訊息:", type);
                this.PushToPacketList(evt.data);
            }
		}
        // let c_event = new CustomEvent("NetMessage",{detail: evt.data});
        // CNetPeer.div.dispatchEvent(c_event);
        // if (evt.data instanceof ArrayBuffer) {
        //     console.log("ArrayBuffer...");
        //     let buffer = evt.data;
        //     let dv = new DataView(buffer);
        //     let offset = 0;

        //     console.log(offset+", "+dv.byteLength);
        //     let type = dv.getUint8(offset);  offset ++;
        //     console.log(type);
        //     let len = dv.getInt32(offset, true);  offset += 4;
        //     console.log(len);
        //     let charArray = new Uint8Array(buffer, offset, len);
        //     let string = new TextDecoder("utf-8").decode(charArray);
        //     offset += len;
        //     let dbid = dv.getInt32(offset, true);
        //     console.log(type + ", " + len + ", " + dbid + "<br>" + string);
        // }
    }
    private onError(evt: any) {
        var msg:string = "("+evt.code+":"+JSON.stringify(evt.data)+")";
        CGame.DebugLog(msg);
		if( this.m_errFunc ) {
            if( this.m_fgConnected ) {
                this.m_errFunc("與"+this.m_Name+"伺服器的連接已斷線!!\n"+msg);
            }
            else {
                this.m_errFunc("連接"+this.m_Name+"伺服器失敗!!\n"+msg);
            }
        }
        this.m_fgConnected = false;
		this.m_WS = null;
        //if( this.m_errFunc ) this.m_errFunc(msg);
    }
    private onClose(evt: any) {
        if( this.m_errFunc ) {
            var msg:string = "("+evt.code+":"+JSON.stringify(evt.data)+")";
            if( this.m_fgConnected ) {
                this.m_errFunc("與"+this.m_Name+"伺服器的連接已斷線!!\n"+msg);
            }
            else {
                this.m_errFunc("連接"+this.m_Name+"伺服器失敗!!\n"+msg);
            }
        }
		this.m_fgConnected = false;
		this.m_WS = null;
        CGame.DebugLog("WebSocket onClose:"+evt.code+":"+JSON.stringify(evt.data));
    }

    public Send(data:CPacket):void {
        // console.log("WebSocket Send:"+data.size);
        if( this.m_fgConnected ) {
            var buf:ArrayBuffer = new ArrayBuffer(data.size);
            var dst:Uint8Array = new Uint8Array(buf);
            var src:Uint8Array = data;
            var i:number;
            for( i = 0; i < data.size; i ++ ) dst[i] = src[i];
            this.m_WS.send(buf);
        }
        else {
            CGame.DebugLog("Send 伺服器的連接已斷線!!");
            // if( this.m_errFunc ) this.m_errFunc("與"+this.m_Name+"伺服器的連接已斷線!!");
        }
    }

    public SendReliable(data:CPacket):void {
		if (!this.m_fgConnected) return;

		let seqID = this.m_nextSeqID++;
		let wrapper = new CPacket(data.size + 5);
		wrapper.WriteByte(CNetPeer.ID_MSG_RELIABLE_DATA);
		wrapper.WriteDWord(seqID);
		wrapper.WriteBytes(data, 0, data.size); // Use underlying Uint8Array

		// Store for retry
		this.m_pendingPackets.set(seqID, {
			pkt: wrapper,
			time: Date.now(),
			retry: 0
		});

		this.Send(wrapper);
	}

	public processReliablePackets():void {
		if (!this.m_fgConnected) return;
		let now = Date.now();
		this.m_pendingPackets.forEach((val, key) => {
			if (now - val.time > 2000) { // 1 second timeout
				if (val.retry >= 3) {
					console.log("##### Reliable packet timeout, giving up: " + key);
					this.m_pendingPackets.delete(key);
					// Optionally disconnect or error
                    this.CloseConnect();
				} else {
					val.retry++;
					val.time = now;
					this.Send(val.pkt);
					console.log("##### Resending reliable packet: ", key, val.retry);
				}
			}
		});
	}
}